import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/storage'
import 'firebase/compat/messaging'
import 'firebase/compat/functions'    
import { app_config } from '../../src/constants'

const config = {
  test: {
    apiKey: "AIzaSyCvpJxEC5Li4Il49syhcgitvs7FngaIaW4", //test 
    authDomain: 'glp-test-f6590.firebaseapp.com',
    databaseURL: 'https://glp-test-f6590.firebaseio.com',
    projectId: 'glp-test-f6590',
    storageBucket: 'glp-test-f6590.appspot.com',
    messagingSenderId: '809505702015',
    appId: '1:809505702015:web:838b987f342ee57bf27f4a'
  },
  live: {
    //apiKey: "AIzaSyB09CxpGugLnlAXX8LceFyj8D6RZSDb0VA", //live unrestricted
    apiKey: "AIzaSyAw-jO5bEzGEOInFnvkNLYgTxgIJzLaNk8", //live restricted
    authDomain: "leadershipplatform-158316.firebaseapp.com",
    databaseURL: "https://leadershipplatform-158316.firebaseio.com",
    projectId: "leadershipplatform-158316",
    storageBucket: "leadershipplatform-158316.appspot.com",
    messagingSenderId: "438289288307",
    appId: "1:438289288307:web:5a8fafc9aeb1164e6cee06"
  },
  public_test: {
    //apiKey: "AIzaSyCvpJxEC5Li4Il49syhcgitvs7FngaIaW4", //test 
    //apiKey: "AIzaSyB09CxpGugLnlAXX8LceFyj8D6RZSDb0VA", //live unrestricted
    apiKey: "AIzaSyAw-jO5bEzGEOInFnvkNLYgTxgIJzLaNk8", //live restricted
    authDomain: 'thinklead-b3299.firebaseapp.com',
    databaseURL: 'https://thinklead-b3299.firebaseio.com',
    projectId: 'thinklead-b3299',
    storageBucket: 'thinklead-b3299.appspot.com',
    messagingSenderId: '595347650471',
    appId: '1:595347650471:web:89d012f77aad33e80f2882'
  }
}

firebase.initializeApp(config[app_config.DB_CONFIG])

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(() => console.log('✅ fbConfig: persistence set to LOCAL'))
  .catch(e => console.warn('⚠️ fbConfig: persistence error:', e));

export default firebase